import { useEffect } from "react";

export default function HideLegacyConvocoreSection() {
  useEffect(() => {
    const hideLegacyConvocore = () => {
      const headings = Array.from(
        document.querySelectorAll("h1, h2, h3, h4, p, span")
      );

      headings.forEach((element) => {
        const text = (element.textContent || "").trim().toLowerCase();

        if (text !== "convocore ai") return;

        const legacySection =
          element.closest("section") ||
          element.closest("article") ||
          element.closest(".section") ||
          element.closest("div");

        if (!legacySection) return;
        if (legacySection.id === "business-tools") return;
        if (legacySection.closest("#business-tools")) return;

        legacySection.style.display = "none";
        legacySection.setAttribute("data-hidden-legacy-convocore", "true");
      });
    };

    hideLegacyConvocore();

    const observer = new MutationObserver(hideLegacyConvocore);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  return null;
}
